"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.initialState = void 0;
var _checkSourceTypes = require("@studio/sources/checkSourceTypes");
var _types = require("../../actions/broadcast/types");
var _types2 = require("../../actions/program/types");
var _types3 = require("../../actions/sceneLayer/types");
var _types4 = require("../../actions/types/types.generic");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var initialState = exports.initialState = ['SCENE_LAYER'];
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
    payload = action.payload,
    _action$sceneLayerSou = action.sceneLayerSources,
    sceneLayerSources = _action$sceneLayerSou === void 0 ? {} : _action$sceneLayerSou;
  if (["".concat(_types.GET_BROADCAST, "_SUCCESS"), "".concat(_types2.BROADCAST_SET_PROGRAM, "_SUCCESS"), "".concat(_types4.BROADCAST_SYNC_LAYER_SOURCES, "_SUCCESS")].includes(type)) {
    var globalSceneLayers = payload.globalSceneLayers;
    return globalSceneLayers.length ? globalSceneLayers : state;
  }
  if (type === _types2.BROADCAST_SET_PROGRAM) {
    return sceneLayersBasedOnProgram(payload, sceneLayerSources);
  }
  if ([_types3.BROADCAST_SET_SCENE_LAYERS, "".concat(_types3.BROADCAST_UPDATE_SCENE_LAYERS, "_SUCCESS")].includes(type)) {
    return payload || state;
  }
  return state;
}

/**
 * payload is program with animations applied
 */
function sceneLayersBasedOnProgram(scene, sceneLayerSources) {
  var layers = scene.layers,
    style = scene.style;
  var _sceneLayerSources$ov = sceneLayerSources.overlays,
    overlays = _sceneLayerSources$ov === void 0 ? [] : _sceneLayerSources$ov,
    _sceneLayerSources$ba = sceneLayerSources.backgrounds,
    backgrounds = _sceneLayerSources$ba === void 0 ? [] : _sceneLayerSources$ba;
  var liveBackgroundId = style === null || style === void 0 ? void 0 : style.backgroundId;
  var nextState = initialState;
  // The image layers contain all image source types - overlays + image sources
  var imageLayers = layers === null || layers === void 0 ? void 0 : layers.filter(function (item) {
    return (0, _checkSourceTypes.isImageSource)(item === null || item === void 0 ? void 0 : item.source);
  });
  var sceneBackground = backgrounds === null || backgrounds === void 0 ? void 0 : backgrounds.find(function (b) {
    return b._id === liveBackgroundId;
  });
  var sceneOverlays = overlays === null || overlays === void 0 ? void 0 : overlays.filter(function (o) {
    return !!imageLayers.find(function (l) {
      return l._id === o._id;
    });
  });
  if (sceneBackground) {
    sceneBackground.source.hidden = false;
    nextState = [sceneBackground].concat(_toConsumableArray(nextState));
  }
  if (sceneOverlays.length) {
    nextState = [].concat(_toConsumableArray(nextState), _toConsumableArray(sceneOverlays));
  }
  return nextState;
}